import { createStore } from '@stencil/store';
import { IClientInfoData } from '../subcomponents/score-dashboard/subcomponents/score-info/types';
import { ICreditScoreData } from '../subcomponents/score-dashboard/subcomponents/score-result/types';
import { IScoreReportPayload } from '../types/api';
import { IScoreSummaryResponse } from '../types/api';

interface ICreditScoreState {
  creditScoreData?: ICreditScoreData;
  clientInfoData?: IClientInfoData;
  reportPayload?: IScoreReportPayload;
  isLoading: boolean;
  fetchError?: string;
  scoreId?: string;
  scoreSummary?: IScoreSummaryResponse;
  selectedConsultationId?: string;
}

export const creditScoreStore = createStore<ICreditScoreState>({
  creditScoreData: undefined,
  clientInfoData: undefined,
  reportPayload: undefined,
  isLoading: false,
  fetchError: undefined,
  scoreId: undefined,
  scoreSummary: undefined,
  selectedConsultationId: undefined,
});

export function getCreditScoreData(): ICreditScoreData | undefined {
  return creditScoreStore.state.creditScoreData;
}

export function getClientInfoData(): IClientInfoData | undefined {
  return creditScoreStore.state.clientInfoData;
}

export function getReportPayload(): IScoreReportPayload | undefined {
  return creditScoreStore.state.reportPayload;
}

export function getIsLoading(): boolean {
  return creditScoreStore.state.isLoading;
}

export function getFetchError(): string | undefined {
  return creditScoreStore.state.fetchError;
}

export function setCreditScoreData(data?: ICreditScoreData): void {
  creditScoreStore.state.creditScoreData = data;
}

export function setClientInfoData(data?: IClientInfoData): void {
  creditScoreStore.state.clientInfoData = data;
}

export function setReportPayload(payload?: IScoreReportPayload): void {
  creditScoreStore.state.reportPayload = payload;
}

export function setIsLoading(value: boolean): void {
  creditScoreStore.state.isLoading = value;
}

export function setFetchError(message?: string): void {
  creditScoreStore.state.fetchError = message;
}

export function setScoreId(scoreId?: string): void {
  creditScoreStore.state.scoreId = scoreId;
}

export function getScoreId(): string | undefined {
  return creditScoreStore.state.scoreId;
}

export function setScoreStoreSummary(summary?: IScoreSummaryResponse): void {
  creditScoreStore.state.scoreSummary = summary;
}

export function getScoreStoreSummary(): IScoreSummaryResponse | undefined {
  return creditScoreStore.state.scoreSummary;
}

export function setSelectedConsultationId(id?: string): void {
  creditScoreStore.state.selectedConsultationId = id;
}

export function getSelectedConsultationId(): string | undefined {
  return creditScoreStore.state.selectedConsultationId;
}

export function resetCreditScoreStore(): void {
  creditScoreStore.state.creditScoreData = undefined;
  creditScoreStore.state.clientInfoData = undefined;
  creditScoreStore.state.reportPayload = undefined;
  creditScoreStore.state.isLoading = false;
  creditScoreStore.state.fetchError = undefined;
  creditScoreStore.state.scoreId = undefined;
  creditScoreStore.state.scoreSummary = undefined;
  creditScoreStore.state.selectedConsultationId = undefined;
}
